<template>
  <v-container>
    <v-data-table
      :key="key"
      :headers="headers"
      :items="items"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar style="border-radius: 5px 5px 0px 0px" color="indigo" dense>
          <v-toolbar-title class="white--text">
            Cronologia modifiche
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="salvaTabella()"
                class="mr-5"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="success">mdi-floppy</v-icon></v-btn
              >
            </template>
            <span>Salva tabella</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="addCronologia()"
                class="mr-5"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="primary">mdi-plus</v-icon></v-btn
              >
            </template>
            <span>Aggiungi</span>
          </v-tooltip>
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="getModifiche()"
                class="mr-5"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="purple">mdi-refresh</v-icon></v-btn
              >
            </template>
            <span>Aggiorna</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="$router.push('/home/')"
                class="mr-5"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="red">mdi-keyboard-backspace</v-icon></v-btn
              >
            </template>
            <span>Indietro</span>
          </v-tooltip>
        </v-toolbar>
      </template>
      <template v-slot:[`item.modifica`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="modificaCronologia(item)"
              small
              :disabled="item.id_update != -1 ? true : false"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="primary"> mdi-pencil </v-icon>
            </v-btn>
          </template>
          <span>Mostra Dettagli</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.specifica`]="{ item }">
        <v-checkbox disabled v-model="item.specifica"> </v-checkbox>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" persistent>
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Cronologia modifiche
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-show="modifica"
                @click="salvaModifica()"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success">mdi-content-save-edit </v-icon>
              </v-btn>
            </template>
            <span>Conferma modifica</span>
          </v-tooltip>
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-show="!modifica"
                @click="aggiungiItem()"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="primary"> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Aggiungi</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="chiudiDialog()" small v-bind="attrs" v-on="on">
                <v-icon color="red"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="3">
                <v-text-field
                  v-model="cronologiaSelezionata.des_script"
                  label="Descrizione"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <GraphQueryFormatter
                  v-model="cronologiaSelezionata"
                  :template="[]"
                  query_field="query_script"
                  :key="renderFormatter"
                />
              </v-col>
              <v-col cols="1">
                <v-checkbox
                  v-model="cronologiaSelezionata.specifica"
                  label="Specifica"
                  dense
                  @change="checkAzienda()"
                ></v-checkbox>
              </v-col>
              <v-col cols="2">
                <v-autocomplete
                  v-model="cronologiaSelezionata.id_azienda"
                  :items="aziende"
                  :disabled="!cronologiaSelezionata.specifica"
                  outlined
                  dense
                  label="Azienda"
                  item-text="ragione_sociale"
                  item-value="id_azienda"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-overlay :value="overlay" style="z-index: 10">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <SnackbarQV ref="SnackbarQV" />
  </v-container>
</template>
<script>
class cronologia {
  constructor(arg = undefined) {
    if (arg == undefined) {
      this.id_update = -1;
      this.des_script = "";
      this.query_script = "";
      this.online = null;
      this.specifica = 0;
      this.id_azienda = null;
      this.ragione_sociale = "";
    } else {
      this.id_update = arg.id_update == undefined ? -1 : arg.id_update;
      this.des_script = arg.des_script == undefined ? "" : arg.des_script;
      this.query_script = arg.query_script == undefined ? "" : arg.query_script;
      this.online = arg.online == undefined ? null : arg.online;
      this.specifica = arg.specifica == undefined ? 0 : arg.specifica;
      this.id_azienda = arg.id_update == undefined ? -1 : arg.id_azienda;
      this.ragione_sociale =
        arg.ragione_sociale == undefined ? "" : arg.ragione_sociale;
    }
  }
}
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import GraphQueryFormatter from "@/components/GRAPH/Dashboard/Editor/QueryParser/QueryEditor.vue";
export default {
  name: "GestioneModificheDB",
  components: { SnackbarQV, GraphQueryFormatter },
  props: {},
  data() {
    return {
      items: [],
      aziende: [],
      modifica: false,
      indice: null,
      overlay: false,
      key: 0,
      renderFormatter:0,
      dialog: false,
      cronologiaSelezionata: new cronologia(),
      headers: [
        {
          text: "Modifica",
          value: "modifica",
          sortable: false,
        },
        {
          text: "N° Versione",
          value: "id_update",
          align: "center",
          width: "100",
        },
        {
          text: "Descrizione",
          value: "des_script",
          sortable: false,
        },
        {
          text: "Query",
          value: "query_script",
        },
        {
          text: "Online",
          value: "online",
        },
        {
          text: "Specifica",
          value: "specifica",
          align: "center",
        },
        {
          text: "Azienda",
          value: "ragione_sociale",
          align: "center",
        },
      ],
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    checkSpecifica() {
      if (this.cronologiaSelezionata.specifica) {
        console.log(this.cronologiaSelezionata);
        if (this.cronologiaSelezionata.id_azienda == null) {
          this.$refs.SnackbarQV.print(
            "orange",
            "Se la modifica è specifica selezionare l'azienda di riferimento!"
          );
          return false;
        } else return true;
      } else return true;
    },
    checkAzienda() {
      console.log(this.cronologiaSelezionata.specifica);
      if (!this.cronologiaSelezionata.specifica)
        this.cronologiaSelezionata.id_azienda = null;
    },
    chiudiDialog() {
      this.dialog = false;
      this.cronologiaSelezionata = new cronologia();
      this.modifica = false;
    },
    addCronologia() {
      this.renderFormatter++;
      this.modifica = false;
      this.dialog = true;
      this.cronologiaSelezionata = new cronologia();
    },
    aggiungiItem() {
      if (
        this.cronologiaSelezionata.des_script == "" ||
        this.cronologiaSelezionata.des_script == null ||
        this.cronologiaSelezionata.query_script == "" ||
        this.cronologiaSelezionata.query_script == null
      ) {
        console.log(this.cronologiaSelezionata);
        this.$refs.SnackbarQV.print(
          "orange",
          "Inserire una descrizione ed una query per la modifica corrente."
        );
        return;
      } else {
        if (!this.checkSpecifica()) return;
        this.aziende.forEach((e) => {
          if (this.cronologiaSelezionata.id_azienda == e.id_azienda)
            this.cronologiaSelezionata.ragione_sociale = e.ragione_sociale;
        });
        this.items.push(this.cronologiaSelezionata);
        this.chiudiDialog();
      }
    },
    modificaCronologia(item) {
      this.modifica = true;
      this.dialog = true;
      this.indice = this.items.indexOf(item);
      this.cronologiaSelezionata = Object.assign({}, new cronologia(item));
    },
    salvaModifica() {
      if (!this.checkSpecifica()) return;
      this.items[this.indice] = Object.assign({}, this.cronologiaSelezionata);
      this.items[this.indice].ragione_sociale = "";
      this.aziende.forEach((e) => {
        if (this.items[this.indice].id_azienda == e.id_azienda)
          this.items[this.indice].ragione_sociale = e.ragione_sociale;
      });

      console.log(this.items, this.cronologiaSelezionata);
      this.key++;
      this.dialog = false;
      this.cronologiaSelezionata = new cronologia();
    },
    getModifiche() {
      this.overlay = true;
      let request = {
        controller: "Token",
        method: "POST",
        richiesta: {
          action: "getcronologiamodifiche",
          token: localStorage.user_token,
        },
      };
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.items = res.data.modifiche;
            this.aziende = res.data.aziende;
          } else
            this.$refs.SnackbarQV.print("orange", "Nessuna modifica trovata!");
        })
        .catch((ex) => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "orange",
            `${JSON.parse(ex.response.data.message).result}.`
          );
        });
    },
    salvaTabella() {
      this.items.forEach((e) => {
        e.query_script = e.query_script
          .replaceAll(/[\n\t]/g, " ")
          .replaceAll(/[\n\r]/g, " ")
          .replaceAll(/[\n]/g, " ");
        if (e.specifica) e.specifica = 1;
        else e.specifica = 0;
      });
      this.overlay = true;
      let request = {
        controller: "Token",
        method: "PUT",
        richiesta: {
          action: "setcronologiamodifiche",
          token: localStorage.user_token,
          modifiche: this.items,
        },
      };
      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.getModifiche();
            this.$refs.SnackbarQV.print(
              "success",
              "Salvataggio effettuato con successo"
            );
          } else
            this.$refs.SnackbarQV.print(
              "orange",
              "Problema durante il salvataggio"
            );
        })
        .catch((ex) => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "orange",
            `${JSON.parse(ex.response.data.message).result}.`
          );
        });
    },
  },
  created() {},
  mounted() {
    this.getModifiche();
  },
};
</script>
<style scoped>
</style>